
// si_frontend/src/config/index.js
export const URLAPI = (window._env_ && window._env_.REACT_APP_URL_BACK) || process.env.REACT_APP_URL_BACK || "http://localhost:8000";
export const WEBSOCKET = (window._env_ && window._env_.REACT_APP_WS_BACK) || process.env.REACT_APP_WS_BACK || "ws://localhost:8000";

export const LOGIN_PATH = "/token/";
export const TASK_PATH = "/employee/task/"


export const GET_SETTINGS_ALL_PATH = "/settings/"

export const COMPANY_PATH = "/company/list/";
export const COMPANY_UPDATE_PATH = "/company/update/";
export const COMPANY_CREATE_PATH = "/company/create/";

export const COST_CENTER_PATH = "/cost-center/list/";
export const COST_CENTER_UPDATE_PATH = "/cost-center/update/";
export const COST_CENTER_CREATE_PATH = "/cost-center/create/";
export const ZONE_PATH = "/zone/list/";
export const ZONE_UPDATE_PATH = "/zone/update/";
export const ZONE_CREATE_PATH = "/zone/create/";
export const EMPLOYEE_PATH = "/employee/list/";
export const VISITORS_PATH = "/employee/visitors-list/";
export const EMPLOYEE_UPDATE_PATH = "/employee/update/";
export const EMPLOYEE_CREATE_PATH = "/employee/create/";
export const EMPLOYEE_CREATE_LINK_PATH  = "/employee/photo-upload-link/create/";
export const EMPLOYEE_UPDATEPHOTO_PATH = "/employee/updatephoto/";
export const EMPLOYEE_IMPORT_PATH = "/employee/import/";
export const EMPLOYEE_REPORT_PATH = "/employee/report/";
export const EMPLOYEE_REPORT_CHECK_PATH = "/employee/report/check/";
export const EMPLOYEE_VALIDATE_LINK_PATH = "/employee/validate-link-photo/";


export const JOBS_PATH = "/job/list/";
export const JOBS_UPDATE_PATH = "/job/update/";
export const JOBS_CREATE_PATH = "/job/create/";

export const SUPPLIER_PATH = "/supplier/list/";
export const SUPPLIER_UPDATE_PATH = "/supplier/update/";
export const SUPPLIER_DELETE_PATH = "/supplier/delete/";
export const SUPPLIER_CREATE_PATH = "/supplier/create/";

export const USERS_PATH = "/user/list/";
export const USERS_UPDATE_PATH = "/user/update/";
export const USERS_CREATE_PATH = "/user/create/";
export const USER_GROUPS_PATH = "/user/group-list/";
export const USER_GET_PATH = "/user/get/";
export const USER_GET_ALL_PERMISSIONS_PATH = '/user/permission-list/';
export const USER_CREATE_GROUP_PATH = '/user/group-create/';
export const USER_UPDATE_GROUP_PATH = '/user/group-update/';
export const USER_ACTIVATE_PATH = '/user/activate/';
export const USER_LOGOUT_PATH = '/user/logout/';
export const USER_PASSWORD_RESET_PATH = '/user/password/reset/';
export const USER_PASSWORD_RESET_CONFIRM_PATH = '/user/password/reset/confirm/';
export const USERS_UPDATE_PASSWORD_PATH = "/user/update-password/";

export const VISITANT_PATH = "/visitant/list/";
export const VISITANT_UPDATE_PATH = "/visitant/update/";
export const VISITANT_DELETE_PATH = "/visitant/delete/";
export const VISITANT_CREATE_PATH = "/visitant/create/";


export const VISITS_PATH = "/visit/list/";
export const VISITS_UPDATE_PATH = "/visit/update/";
export const SEARCH_VISITANT_PATH = '/employee/employees-supplier-visitant-list/';
export const VISITS_CREATE_PATH = "/visit/create/";
export const VISITS_REPORT_PATH = "/visit/report/"
export const VISITS_REPORT_CHECK_PATH = "/visit/report/check/"

export const EMAIL_CREATE_PATH = "/zone/email/create/";
export const EMAIL_UPDATE_PATH = "/zone/email/update/";
export const EMAIL_DELETE_PATH = "/zone/email/delete/";

export const TYPE_NOVELTY_PATH = "/novelty/type/list/";
export const TYPE_NOVELTY_CREATE_PATH = "/novelty/type/create/";
export const TYPE_NOVELTY_UPDATE_PATH = "/novelty/type/update/";
export const TYPE_NOVELTY_DELETE_PATH = "/novelty/type/delete/";

export const OPERATOR_PATH = "/novelty/operator/list/";
export const OPERATOR_CREATE_PATH = "/novelty/operator/create/";
export const OPERATOR_UPDATE_PATH = "/novelty/operator/update/";
export const OPERATOR_DELETE_PATH = "/novelty/operator/delete/";

export const NOVELTY_PATH = "/novelty/list/";
export const NOVELTY_CREATE_PATH = "/novelty/create/";
export const NOVELTY_REPORT_PATH = "/novelty/report/";

export const REPORT_YEARS_PATH = "/report/years/";
export const REPORT_OPTIONS_PATH = "/report/options/";
export const REPORT_PREVIEW_PATH = "/report/preview/";
export const REPORT_EXPORT_PATH = "/report/export/";

// Theme compartido para react-select — reemplaza el azul #2684FF por primary #F9BE2D
export const primarySelectTheme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary:   '#F9BE2D',
        primary75: '#D4A017',
        primary50: 'rgba(249,190,45,0.3)',
        primary25: 'rgba(249,190,45,0.1)',
        neutral0:  '#374151',
        neutral5:  '#1F2937',
        neutral10: '#4B5563',
        neutral20: '#4B5563',
        neutral30: '#6B7280',
        neutral40: '#9CA3AF',
        neutral50: '#9CA3AF',
        neutral60: '#D1D5DB',
        neutral70: '#E5E7EB',
        neutral80: '#F9FAFB',
        neutral90: '#FFFFFF',
    },
});

// Styles explícitos para react-select (override definitivo sobre CSS-in-JS azul)
export const primarySelectStyles = {
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? '#F9BE2D'
            : state.isFocused
            ? 'rgba(249,190,45,0.15)'
            : 'transparent',
        color: state.isSelected ? '#111827' : '#F9FAFB',
        cursor: 'pointer',
        ':active': { backgroundColor: '#D4A017' },
    }),
    control: (base, state) => ({
        ...base,
        backgroundColor: '#374151',
        borderColor: state.isFocused ? '#F9BE2D' : '#4B5563',
        boxShadow: state.isFocused ? '0 0 0 1px #F9BE2D' : 'none',
        '&:hover': { borderColor: '#F9BE2D' },
    }),
    multiValue: (base) => ({ ...base, backgroundColor: '#F9BE2D' }),
    multiValueLabel: (base) => ({ ...base, color: '#111827' }),
    multiValueRemove: (base) => ({
        ...base,
        color: '#111827',
        ':hover': { backgroundColor: '#D4A017', color: '#111827' },
    }),
    menu: (base) => ({ ...base, backgroundColor: '#1F2937', border: '1px solid #374151' }),
    menuList: (base) => ({ ...base, backgroundColor: '#1F2937' }),
    singleValue: (base) => ({ ...base, color: '#F9FAFB' }),
    placeholder: (base) => ({ ...base, color: '#9CA3AF' }),
    input: (base) => ({ ...base, color: '#F9FAFB' }),
    dropdownIndicator: (base) => ({ ...base, color: '#9CA3AF' }),
    clearIndicator: (base) => ({
        ...base,
        color: '#9CA3AF',
        ':hover': { color: '#F87171' },
    }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: '#4B5563' }),
    loadingMessage: (base) => ({ ...base, color: '#9CA3AF' }),
    noOptionsMessage: (base) => ({ ...base, color: '#9CA3AF' }),
};

const BASE_CREADO = "CREADO";
const BASE_EN_ESPERA = "EN ESPERA";
const BASE_APROBADO = "APROBADO";
const BASE_ANULADO = "ANULADO";
const BASE_CADUCADO = "CADUCADO";

export const get_status = (status)  => {
    switch (status) {
        case BASE_CREADO:
            return 'primary';
        case BASE_EN_ESPERA:
            return 'warning';
        case BASE_APROBADO:
            return 'success';
        case BASE_ANULADO:
            return 'danger';
        case BASE_CADUCADO:
            return 'dark';
        default:
            return 'primary';
    }
}


export const TYPE_EMPLOYEE = "EMPLOYEE";
export const TYPE_VISITANT = "VISITANT";
export const TYPE_ALL = "ALL";
export const TYPE_COMPANY = "COMPANY";

export const APP_NAME = "Sistema de Ingreso";


export const URL_FILE_UPLOAD_EMPLOYEE = "URL_FILE_UPLOAD_EMPLOYEE";

